import { Tree } from "~/FreeCapacityPush/components/Tree/Tree";
import classes from "./FCCTree.module.less";
import { TextWithHighlight } from "~/common/components/TextWithHighlight";
import { Stacker } from "~/common/components/Stacker/Stacker";
import { LinkButton } from "~/common/components/Link";
import { useTranslation } from "react-i18next";

export interface FCCTreeNode {
  key: string;
  label: string;
  quantity: number;
  children: FCCTreeNode[];
}

interface Props {
  className?: string;
  items: FCCTreeNode[];
  searchTerm: string;
  selected: string | null;
  setSelected: (selected: FCCTreeNode | null) => void;
  expanded: string[];
  setExpanded: (expanded: string[]) => void;
  onReset?: () => void;
}

export const FCCTree = ({ expanded, setExpanded, onReset, ...props }: Props) => {
  const { t } = useTranslation();
  const selected = props.selected ? [props.selected] : [];
  const renderItem = (item: FCCTreeNode) => renderNode(item, props.searchTerm);
  return (
    <Stacker gap={24}>
      <Tree
        onToggleExpandItem={(key: string, isExpanded: boolean) => {
          if (isExpanded) {
            setExpanded([...expanded, key]);
          } else {
            setExpanded(expanded.filter((k) => k !== key));
          }
        }}
        expanded={expanded}
        selected={selected}
        onSelectItem={(item: FCCTreeNode, isSelected: boolean) => {
          props.setSelected(isSelected ? item : null);
        }}
        items={props.items}
        renderItem={renderItem}
      />
      {onReset && (
        <LinkButton onClick={onReset} className={classes.reset}>
          {t("page.linear.links.reset")}
        </LinkButton>
      )}
    </Stacker>
  );
};

const renderNode = (item: FCCTreeNode, searchTerm: string) => {
  return (
    <div className={classes.node}>
      <TextWithHighlight highlight={searchTerm} highlightClass={classes.highlight}>
        {item.label}
      </TextWithHighlight>
      <span className={classes.qty}>({item.quantity})</span>
    </div>
  );
};
